<template>
  <div>
    <data-table ref="dataTable" :option="option" class="tablebe">
      <template slot="rowAction" slot-scope="text, record">
        <a-button type="link" size="small" @click="checkDetail(record)"
          >详情</a-button
        >
        <a-divider type="vertical" />
        <a-popconfirm
          title="确定移除黑名单吗?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="removeBlackList(record)"
        >
          <a-button type="link" size="small">移除黑名单</a-button>
        </a-popconfirm>
      </template>
    </data-table>
    <GuestDetail ref="GuestDetail"></GuestDetail>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import GuestDetail from "./GuestDetail";
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: "BlackList",
  components: {
    DataTable,
    GuestDetail
  },
  data() {
    return {
      option: {}
    };
  },
  created() {
    this.option = {
      headSearch: {
        width: 400,
        colnum: 1,
        content: [
          {
            label: "关键字",
            name: "KeyWord",
            props: {
              placeholder: "姓名/联系方式"
            }
          }
        ],
        onSubmitBefore: values => {
          return values;
        }
      },
      grid: {
        api: "Guest_List",
        params: { GuestHistoryType: "2" },
        columns: [
          {
            title: "序号",
            width: "4%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "姓名",
            width: "10%",
            dataIndex: "Name"
          },
          {
            title: "性别",
            width: "7%",
            dataIndex: "Sex"
          },
          {
            title: "联系方式",
            width: "10%",
            dataIndex: "Phone"
          },
          {
            title: "类型",
            width: "7%",
            dataIndex: "TypeName"
          },
          {
            title: "住店次数",
            width: "7%",
            dataIndex: "CheckInNum"
          },
          {
            title: "总消费",
            align: "right",
            width: "7%",
            dataIndex: "TotalPrice"
          },
          {
            title: "房费消费",
            align: "right",
            width: "7%",
            dataIndex: "RoomPrice"
          },
          {
            title: "其他消费",
            width: "7%",
            align: "right",
            dataIndex: "OtherPrice"
          },
          {
            title: "备注",
            dataIndex: "Remark"
          },
          {
            title: "操作",
            width: "20%",
            dataIndex: "Action",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    checkDetail(record) {
      this.$refs.GuestDetail.show(record);
    },
    //加入黑名单
    removeBlackList(record) {
      this.$post("Guest_AddBlacklist", {
        Id: record.Id,
        Type: record.MemberCardId != "0" ? 1 : 0
      }).then(() => {
        this.$message.success("操作成功");
        this.$refs.dataTable.headSearch();
      });
    },

    updateGrid() {
      this.$refs.dataTable.headSearch();
    }
  }
};
</script>

<style lang="less" scoped></style>
